<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">예약/취소내역</span>
            <span class="txt">직원 본인에게 예약/취소된 수업 내역을 확인하고 응대합니다.</span>
        </div>

        <div class="com-search-content">
            <div class="line">
                <div class="com-radio">
                    <input
                        id="radio-day-1"
                        v-model="searchDateType"
                        name="radio-day"
                        type="radio"
                        value="S"
                        @click="onSearchList"
                    />
                    <label for="radio-day-1">예약일자</label>
                </div>
                <div class="com-radio">
                    <input
                        id="radio-day-2"
                        v-model="searchDateType"
                        name="radio-day"
                        type="radio"
                        value="L"
                        @click="onSearchList"
                    />
                    <label for="radio-day-2">수업일자</label>
                </div>
                <div class="com-calendar-wrap">
                    <single-calendar :start-date="startDate" @update="startDateUpdate"></single-calendar>
                    <div class="com-dash"><span class="dash">~</span></div>
                    <single-calendar :end-date="endDate" @update="endDateUpdate"></single-calendar>
                </div>
                <select-form
                    :select-data="['기간선택', ...periodTypeList]"
                    :select-value="['', ...periodTypeValueList]"
                    :selected-value="period"
                    @update:set="(val) => (period = val)"
                ></select-form>
                <div class="com-search-input">
                    <input
                        v-model="searchStr"
                        placeholder="이름, 연락처 입력"
                        type="text"
                        v-on:keyup.enter="onEventSearch"
                    />
                    <button class="search-btn" @click="onEventSearch">검색</button>
                </div>
            </div>
            <div class="line">
                <!-- <select-form :select-data='["강사명"]'></select-form> -->
                <select-form
                    :select-data="['예약상태', ...statusTypeList]"
                    :select-value="['', ...statusTypeValueList]"
                    :selected-value="status"
                    @update:set="(val) => (status = val)"
                ></select-form>
                <select-form
                    :select-data="['디바이스', ...deviceTypeList]"
                    :select-value="['', ...deviceTypeValueList]"
                    :selected-value="device"
                    @update:set="(val) => (device = val)"
                ></select-form>
                <button class="com-search-reset" @click="resetSearchContent"></button>
            </div>
        </div>

        <p class="sub-title">회원목록</p>

        <div class="com-table-content">
            <div class="com-btn-area">
                <div class="left-box">
                    <button class="com-btn excel" @click="execlDownload">엑셀 다운로드</button>
                </div>
            </div>
            <table class="com-table">
                <colgroup>
                    <col style="width: 175px" />
                    <col style="width: 135px" />
                    <col style="width: 450px" />
                    <col style="width: 170px" />
                    <col style="width: 135px" />
                    <col style="width: 100px" />
                    <col style="width: 115px" />
                    <col style="width: 135px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <button>예약시간</button>
                        </th>
                        <th>회원명</th>
                        <th>
                            <button>이용권명</button>
                        </th>
                        <th>
                            <button>수업시간</button>
                        </th>
                        <th>
                            <button>강사명</button>
                        </th>
                        <th>
                            <button>예약상태</button>
                        </th>
                        <th>
                            <button>디바이스</button>
                        </th>
                        <th>
                            <button>예약주체</button>
                        </th>
                    </tr>
                </thead>
                <!-- <tbody>
                    <tr>
                        <td>2019-10-01(목) 19:00</td>
                        <td>김윤경</td>
                        <td class="left">
                            <span class="ico type-1">[개인]</span>
                            <span class="ico type-2">[그룹]</span>
                            <span class="ico type-3">[패키지]</span>
                            <span class="ico type-4">[회원권]</span>
                            <span class="ico type-5">[듀엣]</span>
                            <span class="ico type-6">[OT]</span>
                            필라테스 10회 PL + 개인레스 PL 10회
                        </td>
                        <td>2019-12-23 13:00:32</td>
                        <td>김윤경</td>
                        <td>변경예약</td>
                        <td>관리자 WEB</td>
                        <td>홍길동</td>
                    </tr>
                    <tr>
                        <td>2019-10-01(목) 19:00</td>
                        <td>김윤경</td>
                        <td class="left">
                            <span class="ico type-1">[개인]</span>
                            필라테스 10회 PL + 개인레스 PL 10회
                        </td>
                        <td>2019-12-23 13:00:32</td>
                        <td>김윤경</td>
                        <td>변경예약</td>
                        <td>관리자 WEB</td>
                        <td>홍길동</td>
                    </tr> -->
                <tbody>
                    <tr v-for="(reserve, index) in reserveList" :key="index">
                        <td>{{ reserve.cth_resv_dt | utcToYMDHmFilter }}</td>
                        <td>{{ reserve.cust_namee }}</td>
                        <td class="left">
                            <span v-if="reserve.cp_ticket_type_cd === 'P'" class="ico type-1">[개인]</span>
                            <span v-if="reserve.cp_ticket_type_cd === 'G'" class="ico type-2">[그룹]</span>
                            <span v-if="reserve.cp_ticket_type_cd === 'C'" class="ico type-3">[쿠폰]</span>
                            <span v-if="reserve.cp_ticket_type_cd === 'T'" class="ico type-4">[회원권]</span>
                            <span v-if="reserve.cp_ticket_type_cd === 'D'" class="ico type-5">[듀엣]</span>
                            <span v-if="reserve.cp_ticket_type_cd === 'O'" class="ico type-6">[OT]</span>
                            <span v-if="reserve.cp_ticket_type_cd === 'S'" class="ico type-8">[운동복]</span>
                            <!--                            <span class="ico">{{ getTicktetType(reserve.clsc_ticket_type_cd) }}</span>-->
                            {{ reserve.cp_namee }}
                            <!-- 필라테스 10회 PL + 개인레스 PL 10회 -->
                        </td>
                        <td>{{ reserve.cth_less_dt | utcToYMDHmFilter }}</td>
                        <td>{{ reserve.cs_namee }}</td>
                        <td>
                            <span
                                :class="{
                                    red: reserve.cth_resv_status_cd == 'RC' || reserve.cth_resv_status_cd == 'CC',
                                }"
                            >
                                {{ convertReserveState(reserve.cth_resv_status_cd) }}
                            </span>
                        </td>
                        <td>{{ convertDeviceState(reserve.cth_resv_dev_cd) }}</td>
                        <td>{{ reserve.rcs_namee }}</td>
                    </tr>
                    <tr v-if="reserveList.length == 0">
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>
            <div class="sort-bottom-area">
                <select-form
                    :select-data="[...sortTypeList]"
                    :select-value="[...sortTypeValueList]"
                    class="float-right"
                    @update:set="changeLimit"
                ></select-form>
            </div>
            <b-pagination
                v-model="pagingInfo.page"
                :per-page="pagingInfo.limit"
                :total-rows="pagingInfo.totalItems"
                align="center"
                aria-controls="my-table"
                first-class="first"
                last-class="last"
                next-class="next"
                prev-class="prev"
                @change="handlerPagenation($event)"
            ></b-pagination>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import moment from 'moment';
import EventBus from '../../../assets/js/eventBus';
import XLSX from 'xlsx';
import { timestampToDate } from '@/assets/js/excelCommon.js';
import { Utils } from '@/assets/js/utils.js';
import { pagingInfo } from '@/assets/js/common';
export default {
    name: 'MypageReserve',
    props: {},
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
    },
    watch: {
        device: function (newValue) {
            this.device = newValue;
            this.onSearchList();
        },
        status: function (newValue) {
            this.status = newValue;
            this.onSearchList();
        },
        startDate: function (newValue) {
            this.startDate = newValue;
            this.onSearchList();
        },
        endDate: function (newValue) {
            this.endDate = newValue;
            this.onSearchList();
        },
        searchDateType: function (newValue) {
            //검색일자 조건
            this.searchDateType = newValue;
            this.onSearchList();
        },
        period: function (newValue) {
            this.period = newValue;
            if (newValue === 'thisMonth') {
                this.startDate = moment().startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'prevMonth') {
                this.startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'today') {
                this.startDate = moment().format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'yesterday') {
                this.startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
            } else if (newValue === 'lastWeek') {
                this.startDate = moment().subtract(7, 'days').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'threeMonth') {
                this.startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'sixMonth') {
                this.startDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'year') {
                this.startDate = moment().subtract(12, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            }
            this.onSearchList();
        },
    },
    data() {
        return {
            centerId: '', //JSON.parse(localStorage.getItem('userInfo')).centerId, //로컬스토리지에서 받아오는 centerId
            centerStaffId: this.$store.state.auth.user.uid,
            // startDate: moment().subtract(3, "months").format("YYYY-MM-DD"),//this.initStartDate(),
            startDate: moment().format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'), //this.initEndDate(),

            status: '', //예약상태
            device: '', //디바이스
            searchDateType: 'S', //기본값 S(예약일자)

            period: 'today', //검색기간 설정
            periodTypeList: ['오늘', '어제', '최근 일주일', '이번 달', '지난 달', '3개월', '6개월', '12개월'],
            periodTypeValueList: [
                'today',
                'yesterday',
                'lastWeek',
                'thisMonth',
                'prevMonth',
                'threeMonth',
                'sixMonth',
                'year',
            ],
            deviceTypeList: ['관리자 WEB', '관리자 APP', '회원APP', '터치모니터'],
            deviceTypeValueList: ['AW', 'AA', 'CA', 'TU'],
            statusTypeList: ['변경예약', '예약대기', '대기취소', '변경취소', '예약', '취소'],
            statusTypeValueList: ['CR', 'RW', 'WC', 'CC', 'RR', 'RC'],

            sortTypeList: [...this.$sortType],
            sortTypeValueList: [...this.$sortTypeValue],
            searchStr: '', //검색어
            reserveList: [],
            pagingInfo: { ...pagingInfo },

            typeClass: '',
        };
    },
    mounted() {
        this.centerId = this.cId; //센터id
        this.init();
    },
    methods: {
        //초기화
        async init() {
            this.pagingInfo.page = 1;
            this.pagingInfo.limit = 10;
            await this.onSearchList(); // 예약취소내역 가져오기
        },
        //예약취소 내역 가져오기
        async onSearchList() {
            try {
                this.isLoading = true;
                const { data } = await this.getReserveList();
                console.log('목록', data);
                this.setPageParams(data, 'center');
                this.reserveList = data.items;
                this.isLoading = false;
                console.log('===> Success Loading reserveList : ', data);
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },
        //마이페이지 예약 조회내역 API 호출
        getReserveList() {
            return api.get(`admin/api/center/${this.centerId}/mypage/lesson/reservation`, {
                params: {
                    searchDateType: this.searchDateType, //검색일자 조건
                    startDate: moment(this.startDate).format('YYYYMMDD'), //시작날짜
                    endDate: moment(this.endDate).format('YYYYMMDD'), //종료날짜
                    centerCustomerName: this.searchStr, //검색어
                    attendanceDevice: this.device, //디바이스
                    reservationStatus: this.status, //예약상태
                    centerStaffId: this.centerStaffId, //스태프 아이디
                    ...this.pagingInfo, //페이지
                },
            });
        },
        // 검색 종료일
        initEndDate() {
            const endDate = moment().format('YYYY-MM-DD');
            return endDate;
        },

        // 검색 시작일
        initStartDate() {
            // const startDate = moment().subtract(3, "months").format("YYYY-MM-DD");
            const startDate = moment().format('YYYY-MM-DD');
            return startDate;
        },
        // 검색 시작일 변경 event
        startDateUpdate(val) {
            this.startDate = val;
        },

        // 검색 종료일 변경 event
        endDateUpdate(val) {
            this.endDate = val;
        },

        // 검색 조건 초기화
        resetSearchContent() {
            this.startDate = this.initStartDate();
            this.endDate = this.initEndDate();
            // this.period = '';
            this.period = 'today';
            this.ticket = '';
            this.centerType = '';
            this.status = '';
            this.searchStr = '';
            this.status = '';
            this.device = '';
            this.onSearchList();
            EventBus.$emit('event:init', 'init');
        },
        onEventSearch(e) {
            if (this.searchStr.length < 2) {
                return;
            }
            this.onSearchList();
        },
        //예약상태변환
        convertReserveState(type) {
            if (type === 'RR') {
                return '예약';
            } else if (type === 'RW') {
                return '예약대기';
            } else if (type === 'RC') {
                return '취소';
            } else if (type === 'CR') {
                return '변경예약';
            } else if (type === 'CC') {
                return '변경취소';
            } else if (type === 'WC') {
                return '대기취소';
            }
        },
        //디바이스상태
        convertDeviceState(type) {
            if (type === 'AW') {
                return '관리자웹';
            } else if (type === 'AA') {
                return '관리자앱';
            } else if (type === 'CA') {
                return '회원앱';
            } else if (type === 'TU') {
                return '터치모니터';
            }
        },
        // 한 페이지에 표시되는 줄 수 변경
        changeLimit(val) {
            this.pagingInfo.limit = val;
            this.onSearchList();
        },

        //페이징 이벤트
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.onSearchList();
        },

        //페이징 Param 설정
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },

        // 예약목록 엑셀 다운로드 기능구현
        async execlDownload() {
            const { data } = await this.getReserveListExcel(); // 엑셀용 요청값

            let excelDownloadArray = [];
            data.items.forEach((reserve) => {
                const temp = {};
                temp['예약시간'] = moment(reserve.clsc_cre_dt).format('YYYY-MM-DD HH:mm:ss');
                temp['회원명'] = reserve.clsc_center_cust_nm;
                temp['이용권명'] = `[${Utils.getPaymentTypeName(reserve.cp_ticket_type_cd)}]${reserve.clsc_less_nm}`;
                temp['수업시간'] = moment(reserve.clsc_less_dt).format('YYYY-MM-DD HH:mm:ss');
                temp['강사명'] = reserve.clsc_less_staff_nm;
                temp['예약명'] = this.convertReserveState(reserve.clsc_resv_status_cd);
                temp['디바이스'] = this.convertDeviceState(reserve.clsc_atnd_dev_cd);
                temp['예약주체'] = reserve.clsc_reserver_staff_nm;
                excelDownloadArray.push(temp);
            });

            /*[Key:value, ...]*/
            const dataWS = XLSX.utils.json_to_sheet(excelDownloadArray);

            // cell width 설정
            const wscols = [
                { wch: 12 },
                { wch: 12 },
                { wch: 20 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
            ];
            dataWS['!cols'] = wscols;

            // cell height 설정
            const wsrows = [{ hpx: 30 }];
            dataWS['!rows'] = wsrows;

            const wb = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(wb, dataWS, '예약목록');
            XLSX.writeFile(wb, '예약목록.xlsx');
        },

        // 엑셀 다운로드를 위한 회원목록
        getReserveListExcel() {
            return api.get(`admin/api/center/${this.centerId}/mypage/lesson/reservation`, {
                params: {
                    page: 1,
                    limit: 10000,
                    searchDateType: this.searchDateType, //검색일자 조건
                    startDate: moment(this.startDate).format('YYYYMMDD'), //시작날짜
                    endDate: moment(this.endDate).format('YYYYMMDD'), //종료날짜
                    centerCustomerName: this.searchStr, //검색어
                    attendanceDevice: this.device, //디바이스
                    reservationStatus: this.status, //예약상태
                    centerStaffId: this.centerStaffId, //스태프 아이디
                },
            });
        },

        // 엑셀에서 수업 시간을 위한 문자열 생성
        clscLessDateStringExcel(clsc_less_dt) {
            const date = new Date(clsc_less_dt);
            return `${timestampToDate(clsc_less_dt)} ${this.addZero(date.getHours())}:${this.addZero(
                date.getMinutes()
            )}:${this.addZero(date.getSeconds())}`;
            console.log(date);
        },

        // 숫자가 0보다 크거나 같고 10보다 작을 때, 앞에 0을 붙여주는 기능
        addZero(num) {
            return num >= 0 && num < 10 ? `0${num}` : num;
        },
    },
};
</script>
<style lang="scss"></style>
